import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import Fido from '../utils/Fido';
import FullscreenMessage from '../components/FullscreenMessage';

function Logout(props) {
	const fido = new Fido();

	const fetchData = (opts) => {
		fido.fetch(props.location.pathname, opts)
			.then((data) => {
				props.logoutCallback();
				props.history.push('/login');
			})
			.catch(error => props.showSnackbar(error.message));
	};

	useEffect(() => {
		fetchData();
		props.updateHeader({title: "sign out", primary: true});

		return () => {
			fido.dropIt();
			props.resetHeader();
		};
	});

	return (
		<FullscreenMessage message="Signing Out..." />
	);
}

Logout.propTypes = {
	updateHeader: PropTypes.func,
	resetHeader: PropTypes.func,
	location: PropTypes.object.isRequired,
	history: PropTypes.object.isRequired,
	showSnackbar: PropTypes.func,
	logoutCallback: PropTypes.func.isRequired
};

export default Logout;